// extracted by mini-css-extract-plugin
export var item = "dW_rX";
export var text = "dW_k0";